import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import "./../../css/table.css";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import moment from "jalali-moment";
import Swal from "sweetalert2";

const GiftCodes = () => {
    const [codes, setCodes] = useState();
    const [search, setSearch] = useState('');

    useEffect(()=>
    {
        axios.get('https://arianaapp.arianaapply.com/panel/show-discount-code')
        .then(res => {
            console.log('show-discount-code', res);
            setCodes(res.data);
        }).catch(err =>{
            console.log('show-discount-code-err', err);
        })
    }, []);

    const deleteHandler = (id) =>
    {
        axios.get(`https://arianaapp.arianaapply.com/panel/delete-discount-code/${id}`)
        .then(res=>{
            console.log('dedleted', res);
            Swal.fire({
                title: 'کد تخفیف شما با موفقیت حذف شد',
                icon: 'success',
            }).then(()=>{
                window.location.reload();
            }).catch(err =>{
                console.log('creat-discount-code-err', err);
                Swal.fire({
                    title: 'کد تخفیف شما حذف نشد',
                    icon: 'error',
                })
            })
        })
    };

    const statusHandler = (id) =>
    {
        axios.get(`https://arianaapp.arianaapply.com/panel/active-deactive-discount-code/${id}`)
        .then(res =>{
            console.log('status-res', res);
            Swal.fire({
                title: 'وضعیت کد تخفیف شما با موفقیت تغییر کرد',
                icon: 'success',
            }).then(()=>{
                window.location.reload();
            })
        }).catch(err =>{
            console.log('status-err', err)
            Swal.fire({
                title: 'وضعیت کد تخفیف شما تغییر نکرد',
                icon: 'error',
            })
        })
    };

    return (
        <div className="index">
        {codes ? (
            <div className="table">
            <div
                style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                margin: "1rem 0",
                }}
            >
                <input
                className="search-input"
                type="search"
                name="search"
                value={search}
                placeholder="جستجو کنید...."
                onChange={(e) => setSearch(e.target.value)}
                />
            </div>
            <table>
                <thead>
                <tr>
                    <td>#</td>
                    <td>کد</td>
                    <td>مقدار تخفیف</td>
                    <td>توضیحات</td>
                    <td>وضعیت</td>
                    <td>تاریخ ساخت</td>
                    <td>عملیات</td>
                </tr>
                </thead>
                <tbody>
                {codes?.filter((p) => p.code.toLowerCase().includes(search)).map((item, i) => (
                    <tr key={item._id}>
                        <td>{i}</td>
                        <td>{item.code}</td>
                        <td>{item.discount}</td>
                        <td>{item.description}</td>
                        <td>{item.status === true ? 'فعال': 'غیر فعال'}</td>
                        <td>
                            {
                            moment(item.created_at, 'YYYY/MM/DD')
                            .locale('fa')
                            .format('YYYY/MM/DD')
                            }
                        </td>
                        <td className="d-flex">
                        <Link to={`/edit-gift-code/${item._id}`}>
                            <button className="success">
                            <FontAwesomeIcon icon={faEdit} />
                            </button>
                        </Link>
                        <button
                            className="danger"
                            onClick={() => deleteHandler(item._id)}
                        >
                            <FontAwesomeIcon icon={faTrash} />
                        </button>
                        <button
                            className="changeStatus"
                            onClick={()=> statusHandler(item._id)}
                        >
                            {
                                item.status === true ? 'غیر فعال کردن' : 'فعال کردن'
                            }
                        </button>
                        </td>
                    </tr>
                    ))}
                </tbody>
            </table>
            </div>
        ) : (
            <Spinner animation="border" variant="primary" />
        )}
        </div>
    );
};

export default GiftCodes;
